import useInsightsSetting from './useInsightsSetting';
import { useEffect, useState } from 'react';
import { extractInsightsListFromSetting } from './insights.formatters';
import _ from 'lodash';

const useInsightsList = insightsValues => {
  const [insightsList, setInsightsList] = useState([]);
  const insightSetting = useInsightsSetting();

  const orderedInsightsList = _.orderBy(insightsList, 'isChecked');

  const toggleCheck = insightKey => {
    const updatedList = insightsList.map(insight => ({
      ...insight,
      ...(insightKey === insight.key && { isChecked: !insight.isChecked })
    }));
    setInsightsList(updatedList);
  };

  const initInsightsList = () => {
    const list = extractInsightsListFromSetting(insightSetting.value);
    const listWithValues = list.map(insight => ({
      ...insight,
      value: insightsValues.data[insight.key],
      isChecked: false
    }));
    setInsightsList(listWithValues);
  };

  useEffect(() => {
    initInsightsList();
  }, [insightSetting.value, insightsValues.data]);

  return {
    items: orderedInsightsList,
    toggleCheck
  };
};

export default useInsightsList;
